import React, { Fragment, Component } from 'react'
import {
  Container,
  Row, Col,
  CardBody, Card, CardTitle, CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { FileInput, generateFormData } from "../../../helpers/ui/FileInput";
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'

import CustomSelect from "../../../helpers/ui/CustomSelect"

class IndexView extends Component {

  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props)
    this.state = {
      portal_service: {},
      dataForm: {},
      optServiceStatus: [
        {
          label: "Aktif",
          value: "1"
        },
        {
          label: "Tidak Aktif",
          value: "0"
        }
      ],
    }
  }

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, {
      field: "attachment_detail",
      name: "portalServiceAttachments/attachment",
    });
    await this.updateBloc.fetchUpdate(formData)
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault()
    this.setState({
      dataForm: values,
      confirm: true
    })
  }

  confirmResponse = (response) => {
    let forState = {}
    switch (response) {
      case 'cancel':
        forState = {
          confirm: false
        }
        break;
      case 'confirm':
        forState = {
          loading: true,
          confirm: false
        }
        this.submitData()
        break;
      case 'success':
        forState = {
          success: false,
          redirect: true
        }
        break;
      case 'failed':
        forState = {
          failed: false
        }
        break;
      default:
    }
    this.setState(forState)
  }

  componentDidMount() {
    this.updateBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break
        default:
          break
      }
    })

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            portal_service: response,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    })

    const queryParams = new URLSearchParams(window.location.search);
    this.updateBloc.fetchDetail({portal_service_id: queryParams.get("id")});
  }

  componentWillUnmount() {
    this.updateBloc.createChannel.unsubscribe();
    this.updateBloc.detailChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Edit Kategori Panduan</CardTitle>
                  <CardSubtitle className="mb-3">
                    Edit kategori panduan dengan mengisi form di bawah ini
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                  >
                    <Col md="3">
                      <AvField
                        name="portal_service_id"
                        type="hidden"
                        validate={{ required: { value: true } }}
                        id="portal_service_id"
                        value={this.state.portal_service.portal_service_id}
                      />
                    </Col>
                    <Row className="mb-3">
                      <label
                        htmlFor="fielCode"
                        className="col-md-3 col-form-label"
                      >
                        Judul Layanan <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="service_title"
                          placeholder="Judul Layanan"
                          type="text"
                          errorMessage="Masukan judul layanan"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.portal_service.service_title}
                          id="service_title"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="is_popup_announcement"
                        className="col-md-3 col-form-label"
                      >
                        Status <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <CustomSelect
                          name="is_active"
                          id="is_active"
                          options={this.state.optServiceStatus}
                          validate={{ required: { value: true } }}
                          defaultValue={""+this.state.portal_service.is_active}
                          placeholder="Pilih Status" />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="fielCode"
                        className="col-md-3 col-form-label"
                      >
                        Warna Background  <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="service_color"
                          placeholder="#EFFEFC"
                          type="text"
                          errorMessage="Masukan warna background"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.portal_service.service_color}
                          id="service_color"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="fielCode"
                        className="col-md-3 col-form-label"
                      >
                        Warna Background Fitur  <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="service_features_color"
                          placeholder="#EFFEFC"
                          type="text"
                          errorMessage="Masukan warna background fitur"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.portal_service.service_features_color}
                          id="service_features_color"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="fielCode"
                        className="col-md-3 col-form-label"
                      >
                        Link Layanan
                      </label>
                      <Col md="9">
                        <AvField
                          name="service_link"
                          placeholder="Link Layanan"
                          type="text"
                          errorMessage="Masukan link layanan"
                          className="form-control"
                          value={this.state.portal_service.service_link}
                          id="service_link"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                        <label className="col-md-3 col-form-label">Icon</label>
                        <Col md={9}>
                          <FileInput
                            name="attachment_detail"
                            accept=".jpg,.png,.svg"
                          />
                        </Col>
                      </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <div className="form-check form-switch mb-3">
                          <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                            <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                          </AvCheckboxGroup>

                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/admin/layanan_portal.html">
                          <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                        </Link>
                        {' '}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan mengubah data ini?"

          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"

          successTitle="Berhasil!"
          successInfo="Data berhasil diubah"

          failedTitle="Gagal!"
          failedInfo="Data gagal diubah"

          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}

          response={this.confirmResponse}
        />
        {this.state.redirect ?
          <Redirect to='/admin/layanan_portal.html' />
          : null}
      </Fragment>
    )
  }

}

export default IndexView